import { Api } from "api";

export const getBudgetRequests = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const from = payload.from_date !== undefined ? `&from_date=${payload.from_date}` : "";
  const to = payload.to_date !== undefined ? `&to_date=${payload.to_date}` : "";
  const company = payload.company_id !== undefined ? `&company_id=${payload.company_id}` : "";
  const department = payload.department_id !== undefined ? `&department_id=${payload.department_id}` : "";
  const creator = payload.creator_name !== undefined ? `&creator_name=${payload.creator_name}` : "";
  const budget = payload.budget_type_id !== undefined ? `&budget_type_id=${payload.budget_type_id}` : "";
  const year = payload.year !== undefined ? `&year=${payload.year}` : "";
  const sortBy =
    Array.isArray(payload.sort_by) && payload.sort_by.length > 0
      ? payload.sort_by.map((s: string) => `&sort_by=${s}`).join("")
      : "";
  const offset = payload.offset !== undefined ? `&offset=${payload.offset}` : "";
  const url = `/budget_request/?hash_pw=${hash}${from}${to}${company}${department}${creator}${budget}${year}${sortBy}${offset}`;

  const res = await Api.get(url);
  return res.data;
};

export const addBudgetRequest = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/budget_request/?hash_pw=${hash}`, payload);
  return res.data;
};

export const updateBudgetRequest = async (requestId: number, payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.put(`/budget_request/${requestId}?hash_pw=${hash}`, payload);
  return res.data;
};

export const getArticles = async (query: string) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/budget-request-details/search/articles?hash_pw=${hash}&q=${query}`);
  return res.data;
};

export const getReportColumns = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/need_columns_for_report/?hash_pw=${hash}`);
  return res.data;
};

export const getReportForecasts = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/need_formulas_for_report/?hash_pw=${hash}`);
  return res.data;
};

export const generateBudgetReport = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const res = await Api.post(`/generate_budget_report/?hash_pw=${hash}`, payload_hash);
  return res.data;
};

export const downloadBudgetReport = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const res = await Api.post(`/download_budget_report/`, payload_hash, { responseType: "blob" });
  return res.data;
};

export const getReportTemplates = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/budget_report_template/?hash_pw=${hash}`);
  return res.data;
};

export const addReportTemplate = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/budget_report_template/?hash_pw=${hash}`, payload);
  return res.data;
};

export const updateReportTemplate = async (templateId: number, payload: any) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const res = await Api.put(`/budget_report_template/?hash_pw=${hash}&template_id=${templateId}`, payload_hash);
  return res.data;
};

export const deleteReportTemplate = async (templateId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.delete(`/budget_report_template/?hash_pw=${hash}&template_id=${templateId}`);
  return res.data;
};

export const saveForecast = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/forecast_budget_row/?hash_pw=${hash}`, payload);
  return res.data;
};

export const getFormulas = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/budget_formula/?hash_pw=${hash}`);
  return res.data;
};

export const createFormula = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/budget_formula/?hash_pw=${hash}`, payload);
  return res.data;
};

export const updateFormula = async (formulaId: number, payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.put(`/budget_formula/?formula_id=${formulaId}&hash_pw=${hash}`, payload);
  return res.data;
};

export const deleteFormula = async (formulaId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.delete(`/budget_formula/?formula_id=${formulaId}&hash_pw=${hash}`);
  return res.data;
};

export const getBudgetBalance = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const company = payload.company_id !== undefined ? `&company_id=${payload.company_id}` : "";
  const department = payload.department_id !== undefined ? `&department_id=${payload.department_id}` : "";
  const year = payload.year !== undefined ? `&year=${payload.year}` : "";
  const levels = payload.budget_levels !== undefined ? `&budget_levels=${payload.budget_levels}` : "";
  const url = `/budgets/balance/by_filters/?hash_pw=${hash}${company}${department}${year}${levels}`;

  const res = await Api.get(url);
  return res.data;
};
